module.exports = __webpack_public_path__ + "img/box.675e88dd.jpg";